import { render, staticRenderFns } from "./embedWidgetInstructions.vue?vue&type=template&id=fa81f6ae&scoped=true&"
import script from "./embedWidgetInstructions.vue?vue&type=script&lang=js&"
export * from "./embedWidgetInstructions.vue?vue&type=script&lang=js&"
import style0 from "./embedWidgetInstructions.vue?vue&type=style&index=0&id=fa81f6ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa81f6ae",
  null
  
)

export default component.exports